const clientToken = import.meta.env.VITE_PAYMENTS_CLIENT_TOKEN as string | undefined;

export function PaymentTestModeBanner() {
  if (!clientToken) {
    return (
      <aside aria-label="Checkout configuration notice" className="w-full border-b border-red-500/40 bg-red-950/40 px-4 py-2 text-center text-xs text-red-200">
        Production checkout is not yet configured. Complete Stripe go-live to accept real payments.
      </aside>
    );
  }
  if (clientToken.startsWith("pk_test_")) {
    return (
      <aside aria-label="Payment test mode notice" className="w-full border-b border-gold/30 bg-obsidian/80 px-4 py-2 text-center text-[11px] uppercase tracking-[0.25em] text-gold">
        Test mode · all payments in the preview are simulated ·{" "}
        <a
          href="https://docs.lovable.dev/features/payments#test-and-live-environments"
          target="_blank"
          rel="noopener noreferrer"
          className="underline"
        >
          learn more
        </a>
      </aside>
    );
  }
  return null;
}
